import React, { ReactNode, useEffect } from 'react';
import AuthLayout from 'components/layout/AuthLayout';
import { Navigate } from 'react-router-dom';
import { useAuth } from 'hooks/auth/AuthElement';
import { useSelector } from 'store/selector';
import { usePermissionRules } from 'hooks/permissionRules';
import history from 'services/history';

type Rule = string;

interface ProtectedRouteProps {
  element: ReactNode;
  rule?: Rule;
}

const PublicRoute: React.FC<ProtectedRouteProps> = ({ element, rule }) => {
  const { checkAuth } = useAuth();
  const user = useSelector(state => state.user);
  const { checkPermission } = usePermissionRules();

  useEffect(() => {
    if (!user) {
      return;
    }

    if (rule && !checkPermission(rule)) {
      history.push('/');
    }
  }, [rule, user, checkPermission]);

  return <>{!checkAuth() ? <AuthLayout>{element}</AuthLayout> : <Navigate to="/" />}</>;
};

export default PublicRoute;
